export const STATUS_LABELS: Record<string, string> = {
  new_application: 'Nowe zgłoszenie',
  initial_verification_ok: 'Wstępna Weryfikacja OK',
  warning_risk: 'Ostrzeżenie - Ryzyko',
  ready_to_write: 'Gotowy do pisania',
  contract_signed: 'Umowa podpisana',
  application_submitted: 'Wniosek złożony',
  success: 'Sukces',
  rejected: 'Odrzucony',
};

export const SERVICE_TYPE_LABELS: Record<string, string> = {
  pup_grant: 'Dotacja PUP',
  wsparcie_na_starcie: 'Wsparcie na Starcie',
  pup_and_loan: 'PUP + Pożyczka',
  consulting: 'Doradztwo',
  zus: 'ZUS Ulgi',
  bhp: 'Szkolenia BHP',
  bhp_ppoz: 'BHP i ppoż (usługi)',
  development_grant: 'Dotacje Rozwojowe',
  loans: 'Pożyczki',
  zus_bhp_grant: 'Dotacja ZUS BHP',
  mediation: 'Mediacja',
  kfs: 'KFS Szkolenia',
  szkolenia: 'Szkolenia',
  turnusy: 'Turnusy',
  wycieczki: 'Wycieczki',
  pozyczki_rozwojowe: 'Pożyczki Rozwojowe',
  czyste_powietrze: 'Czyste Powietrze',
  uslugi_ksiegowe: 'Usługi Księgowe',
  marketing_beauty: 'Marketing Beauty',
  gastro_consulting: 'Gastro Consulting',
  granty_fpn: 'Granty FPN',
  hutnik_biznes: 'Hutnik Business Club',
  dotacje_rozwojowe: 'Dotacje Rozwojowe',
  steam_education: 'STEAM Academia',
};

export const SERVICE_TYPE_COLORS: Record<string, string> = {
  pup_grant: 'bg-blue-100 text-blue-800',
  wsparcie_na_starcie: 'bg-emerald-100 text-emerald-800',
  pup_and_loan: 'bg-purple-100 text-purple-800',
  consulting: 'bg-amber-100 text-amber-800',
  zus: 'bg-red-100 text-red-800',
  bhp: 'bg-orange-100 text-orange-800',
  bhp_ppoz: 'bg-red-100 text-red-700',
  development_grant: 'bg-teal-100 text-teal-800',
  loans: 'bg-cyan-100 text-cyan-800',
  kfs: 'bg-amber-100 text-amber-800',
  zus_bhp_grant: 'bg-green-100 text-green-800',
  mediation: 'bg-violet-100 text-violet-800',
  szkolenia: 'bg-indigo-100 text-indigo-800',
  turnusy: 'bg-orange-100 text-orange-800',
  wycieczki: 'bg-teal-100 text-teal-800',
  pozyczki_rozwojowe: 'bg-cyan-100 text-cyan-800',
  czyste_powietrze: 'bg-green-100 text-green-800',
  uslugi_ksiegowe: 'bg-rose-100 text-rose-800',
  marketing_beauty: 'bg-pink-100 text-pink-800',
  gastro_consulting: 'bg-orange-100 text-orange-800',
  granty_fpn: 'bg-amber-100 text-amber-800',
  hutnik_biznes: 'bg-lime-100 text-lime-800',
  dotacje_rozwojowe: 'bg-teal-100 text-teal-800',
  steam_education: 'bg-purple-100 text-purple-800',
};

export const STATUS_COLORS: Record<string, string> = {
  new_application: 'bg-blue-100 text-blue-800',
  initial_verification_ok: 'bg-green-100 text-green-800',
  warning_risk: 'bg-yellow-100 text-yellow-800',
  ready_to_write: 'bg-purple-100 text-purple-800',
  contract_signed: 'bg-indigo-100 text-indigo-800',
  application_submitted: 'bg-cyan-100 text-cyan-800',
  success: 'bg-emerald-100 text-emerald-800',
  rejected: 'bg-red-100 text-red-800',
};

export const LOAN_STATUS_LABELS: Record<string, string> = {
  inquiry: 'Zapytanie',
  documents_prep: 'Kompletacja dokumentów',
  submitted: 'Wniosek złożony',
  under_review: 'W ocenie',
  approved: 'Zatwierdźony',
  contract_signed: 'Umowa podpisana',
  disbursed: 'Środki wypłacone',
  repaying: 'W trakcie spłaty',
  forgiveness_applied: 'Wniosek o umorzenie',
  forgiven: 'Umorzona',
  completed: 'Spłacona',
  rejected: 'Odrzucony',
};

export const LOAN_STATUS_COLORS: Record<string, string> = {
  inquiry: 'bg-blue-100 text-blue-800',
  documents_prep: 'bg-yellow-100 text-yellow-800',
  submitted: 'bg-indigo-100 text-indigo-800',
  under_review: 'bg-purple-100 text-purple-800',
  approved: 'bg-green-100 text-green-800',
  contract_signed: 'bg-teal-100 text-teal-800',
  disbursed: 'bg-emerald-100 text-emerald-800',
  repaying: 'bg-cyan-100 text-cyan-800',
  forgiveness_applied: 'bg-orange-100 text-orange-800',
  forgiven: 'bg-lime-100 text-lime-800',
  completed: 'bg-gray-100 text-gray-800',
  rejected: 'bg-red-100 text-red-800',
};
